import React, { useState, useEffect } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'

export const MobileNav = () => {
    const navigate = useNavigate();

    const [show, showNav] = useState(false);
    const currentLocation = useLocation();
    const toggleShowNav = () => {
        showNav(!show);
    }
    useEffect(() => {
        showNav(false);
    }, [currentLocation]);

    const logoClick = () => {
        navigate("/")
    }

    useEffect(() => {
        if (show) {
            // Disable scrolling when the menu is open
            document.body.style.overflow = 'hidden';
        } else {
            // Enable scrolling when the menu is closed
            document.body.style.overflow = '';
        }

        // Clean up to restore scrolling when the component unmounts
        return () => {
            document.body.style.overflow = '';
        };
    }, [show]);
    return (
        <div>

            <div id='mobile-header'>
                <img onClick={logoClick} src='images/header-logo.png' width='50px' alt='Dawson Bolen Logo' />
                <div className={`hamburger-menu ${show ? 'open-menu-btn' : ''}`} onClick={toggleShowNav}>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>

            </div>

            {show ? (
                <div id='mobile-menu' className={showNav ? 'open' : ''}>
                    <div id='x-btn-cnt' onClick={toggleShowNav}>
                        <svg
                            id='x-btn'
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            width="40"
                            height="40"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        >
                            <line x1="18" y1="6" x2="6" y2="18" />
                            <line x1="6" y1="6" x2="18" y2="18" />
                        </svg>
                    </div>

                    <ul>
                        <li><Link className='mob-links' to='/'>Home</Link></li>
                        <li><a className='mob-links' href='#work'>Projects</a></li>
                        <li><Link className='mob-links' to='/projects'>More Projects</Link></li>
                        <li><a className='mob-links' href='#abt-home'>About</a></li>
                        <li><a className='mob-links' href='#contactcards'>Contact</a></li>
                    </ul>
                </div>
            ) : (
                <> </>
            )}


        </div>
    )
}
